import { UnitedStates as r } from "./united-states.js";
import { Greenland as o } from "./greenland.js";
import { Canada as m } from "./canada.js";
import { Mexico as i } from "./mexico.js";
import { FalklandIslands as t } from "./falkland-islands.js";
import { Brazil as a } from "./brazil.js";
import { Vietnam as p } from "./vietnam.js";
import { Thailand as f } from "./thailand.js";
import { Taiwan as n } from "./taiwan.js";
import { SouthKorea as e } from "./south-korea.js";
import { Singapore as l } from "./singapore.js";
import { Philippines as d } from "./philippines.js";
import { NewZealand as s } from "./new-zealand.js";
import { Mauritius as u } from "./mauritius.js";
import { Malaysia as c } from "./malaysia.js";
import { Japan as g } from "./japan.js";
import { Indonesia as S } from "./indonesia.js";
import { India as h } from "./india.js";
import { HongKong as y } from "./hong-kong.js";
import { China as C } from "./china.js";
import { Cambodia as I } from "./cambodia.js";
import { Brunei as M } from "./brunei.js";
import { Australia as w } from "./australia.js";
import { VaticanCity as b } from "./vatican-city.js";
import { UnitedKingdom as F } from "./united-kingdom.js";
import { Switzerland as G } from "./switzerland.js";
import { Sweden as L } from "./sweden.js";
import { Spain as k } from "./spain.js";
import { Slovenia as v } from "./slovenia.js";
import { Slovakia as x } from "./slovakia.js";
import { SanMarino as z } from "./san-marino.js";
import { Norway as A } from "./norway.js";
import { Austria as B } from "./austria.js";
import { Romania as K } from "./romania.js";
import { Portugal as N } from "./portugal.js";
import { Poland as P } from "./poland.js";
import { Netherlands as E } from "./netherlands.js";
import { Monaco as H } from "./monaco.js";
import { Malta as R } from "./malta.js";
import { Luxembourg as T } from "./luxembourg.js";
import { Lithuania as U } from "./lithuania.js";
import { Liechtenstein as V } from "./liechtenstein.js";
import { Latvia as D } from "./latvia.js";
import { Italy as J } from "./italy.js";
import { IsleOfMan as O } from "./isle-of-man.js";
import { Iceland as Z } from "./iceland.js";
import { FaroeIslands as j } from "./faroe-islands.js";
import { Estonia as q } from "./estonia.js";
import { Finland as Q } from "./finland.js";
import { France as W } from "./france.js";
import { Germany as X } from "./germany.js";
import { Gibraltar as Y } from "./gibraltar.js";
import { Greece as _ } from "./greece.js";
import { Hungary as $ } from "./hungary.js";
import { CzechRepublic as rr } from "./czech-republic.js";
import { Denmark as or } from "./denmark.js";
import { Egypt as mr } from "./egypt.js";
import { Cyprus as ir } from "./cyprus.js";
import { Croatia as tr } from "./croatia.js";
import { Belgium as ar } from "./belgium.js";
import { Andorra as pr } from "./andorra.js";
const go = {
  UnitedStates: r,
  Greenland: o,
  Canada: m,
  Mexico: i,
  FalklandIslands: t,
  Brazil: a,
  Vietnam: p,
  Thailand: f,
  Taiwan: n,
  SouthKorea: e,
  Singapore: l,
  Philippines: d,
  NewZealand: s,
  Mauritius: u,
  Malaysia: c,
  Japan: g,
  Indonesia: S,
  India: h,
  HongKong: y,
  China: C,
  Cambodia: I,
  Brunei: M,
  Australia: w,
  VaticanCity: b,
  UnitedKingdom: F,
  Switzerland: G,
  Sweden: L,
  Spain: k,
  Slovenia: v,
  Slovakia: x,
  SanMarino: z,
  Norway: A,
  Austria: B,
  Romania: K,
  Portugal: N,
  Poland: P,
  Netherlands: E,
  Monaco: H,
  Malta: R,
  Luxembourg: T,
  Lithuania: U,
  Liechtenstein: V,
  Latvia: D,
  Italy: J,
  IsleOfMan: O,
  Iceland: Z,
  FaroeIslands: j,
  Estonia: q,
  Finland: Q,
  France: W,
  Germany: X,
  Gibraltar: Y,
  Greece: _,
  Hungary: $,
  CzechRepublic: rr,
  Denmark: or,
  Egypt: mr,
  Cyprus: ir,
  Croatia: tr,
  Belgium: ar,
  Andorra: pr
};
export {
  go as Countries
};
